export default {
    table : {
        width: '300px'
    },

    tableHeader: { 
		textAlign:'left'
    }
}


// WEBPACK FOOTER //
// ./src/containers/postevent/components/Styles/postEventManagementStyle.js